import styled from 'styled-components';

import { Icon } from '@/ui/Icon';
import { LiveEventSessionCardMeta } from '@/pages/LiveEvent/LiveEventSessionCardMeta/LiveEventSessionCardMeta';
import { RLocationType } from '@/store/v2';

const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background-color: ${({ theme }) => theme.tones.neutral[99]};
  border-radius: 8px;
`;

const HeadingStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const NameStyled = styled.div`
  ${({ theme }) => theme.typography.title5};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const RadioButtonIconStyled = styled(Icon)`
  width: 14px;
  height: 14px;
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const LiveEventSessionCardMetaContainerStyled = styled.div`
  padding-left: 28px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

type LiveEventHighlightsActiveSessionReservationProps = {
  title: string;
  date: string;
  type?: RLocationType;
};

export const LiveEventHighlightsActiveSessionReservation = ({
  title,
  date,
  type,
}: LiveEventHighlightsActiveSessionReservationProps): JSX.Element => {
  return (
    <RootStyled>
      <HeadingStyled>
        <RadioButtonIconStyled icon={['far', 'circle-check']} />
        <NameStyled>{title}</NameStyled>
      </HeadingStyled>
      <LiveEventSessionCardMetaContainerStyled>
        <LiveEventSessionCardMeta date={date} type={type} />
      </LiveEventSessionCardMetaContainerStyled>
    </RootStyled>
  );
};
